"use client";
import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { useLocaleText as R, Box as x, Paper as L, Group as s, Illustration as w, Paragraph as a, List as H, IconButton as A, Button as F, TextLink as I, sharedHandler as $ } from "@ingeniorforeningen/figurine-core";
import { forwardRef as z, useState as E, useEffect as G } from "react";
import '../../../assets/ProductCard.css';const V = "_root_ec3r8_2", q = "_paper_ec3r8_6", D = "_header_ec3r8_14", J = "_illustration_ec3r8_22", K = "_title_ec3r8_33", M = "_subTitle_ec3r8_43", O = "_text_ec3r8_53", Q = "_priceBox_ec3r8_62", U = "_relative_ec3r8_76", W = "_price_ec3r8_62", X = "_priceSecondary_ec3r8_90", Y = "_terms_ec3r8_102", Z = "_absolute_ec3r8_110", ee = "_mobileButton_ec3r8_114", te = "_link_ec3r8_118", re = "_listRoot_ec3r8_128", e = {
  root: V,
  paper: q,
  header: D,
  illustration: J,
  title: K,
  subTitle: M,
  text: O,
  priceBox: Q,
  relative: U,
  price: W,
  priceSecondary: X,
  terms: Y,
  absolute: Z,
  mobileButton: ee,
  link: te,
  listRoot: re
}, o = z((h, v) => {
  const {
    illustration: g,
    header: l,
    subject: N,
    text: b,
    textList: f,
    price: y,
    priceSecondary: C,
    priceText: k,
    priceTerms: B,
    onChange: m,
    link: d,
    id: P,
    value: n,
    className: S,
    ...T
  } = h, [r, u] = E(n);
  G(() => {
    u(n);
  }, [n]);
  const j = () => {
    m && m(!r), u(!r);
  }, p = R(), c = r ? "light" : "dark";
  return /* @__PURE__ */ i(x, { ...T, ref: v, className: `${e.root} ${S}`, h: "100%", children: [
    /* @__PURE__ */ i(
      L,
      {
        px: "md",
        py: "md",
        className: e.paper,
        id: P || l,
        onClick: j,
        variant: r ? "secondary" : "primary",
        children: [
          /* @__PURE__ */ i(s, { align: "end", mb: "md", spacing: "md", wrap: "nowrap", className: e.header, children: [
            /* @__PURE__ */ t(w, { name: g, className: e.illustration }),
            /* @__PURE__ */ i(s, { direction: "column", spacing: "xs", children: [
              /* @__PURE__ */ t(
                a,
                {
                  text: l,
                  strong: !0,
                  className: e.title,
                  variant: c,
                  lineClamp: 2
                }
              ),
              /* @__PURE__ */ t(
                a,
                {
                  text: N,
                  transform: "uppercase",
                  strong: !0,
                  className: e.subTitle,
                  variant: c
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ t(a, { text: b, strong: !0, variant: c, className: e.text }),
          /* @__PURE__ */ t(
            H,
            {
              icon: "CircleCheck",
              iconColor: r ? "light" : "dark",
              iconSize: "sm",
              lineHeight: "xs",
              spacing: 0,
              items: f.map((_) => ({
                text: /* @__PURE__ */ t(
                  a,
                  {
                    text: _,
                    condensed: !0,
                    variant: c,
                    lineClamp: 2
                  },
                  _
                )
              })),
              mb: "md",
              className: e.listRoot
            }
          ),
          /* @__PURE__ */ i(
            s,
            {
              justify: "center",
              direction: "column",
              className: e.priceBox,
              spacing: 0,
              mod: { active: r },
              children: [
                /* @__PURE__ */ i(s, { justify: "center", spacing: 0, children: [
                  /* @__PURE__ */ t(
                    a,
                    {
                      text: y,
                      strong: !0,
                      className: e.price,
                      variant: c
                    }
                  ),
                  /* @__PURE__ */ t("div", { className: e.relative, children: /* @__PURE__ */ t(
                    a,
                    {
                      text: C,
                      strong: !0,
                      className: e.priceSecondary,
                      variant: c
                    }
                  ) })
                ] }),
                /* @__PURE__ */ t(
                  a,
                  {
                    text: k,
                    transform: "uppercase",
                    align: "center",
                    variant: c,
                    className: e.text
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ t(
            a,
            {
              text: B,
              align: "center",
              className: e.terms,
              variant: r ? "light" : "neutral"
            }
          ),
          /* @__PURE__ */ i(s, { justify: "center", children: [
            /* @__PURE__ */ t(x, { className: e.absolute, hiddenFrom: "md", children: /* @__PURE__ */ t(
              A,
              {
                variant: r ? "cta" : "default",
                icon: r ? "Check" : "Plus",
                circular: !0,
                className: e.mobileButton
              }
            ) }),
            /* @__PURE__ */ t(
              F,
              {
                visibleFrom: "md",
                variant: r ? "cta" : "outline",
                text: r ? p.chosen : p.choose,
                mt: "xl"
              }
            )
          ] })
        ]
      }
    ),
    d && /* @__PURE__ */ t(s, { justify: "center", mt: "xl", children: /* @__PURE__ */ t(
      I,
      {
        variant: "component",
        icon: "ChevronRight",
        iconPlacement: "right",
        ...d,
        className: e.link
      }
    ) })
  ] });
});
o.displayName = "ProductCard";
const ae = $(o);
ae.displayName = o.displayName;
export {
  e as P,
  o as _ProductCard,
  ae as default
};
